import * as m from "../../model/model";

import { RootState } from "..";
import { api } from "../../api/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { workspaceActions } from "./workspaceSlice";

export function handleError(e: unknown, rejectWithValue: Function) {
  console.error(e);
  return rejectWithValue(e);
}

export const createWorkspaceThunk = createAsyncThunk<m.Workspace, string>(
  "workspace/create",
  async (name, { dispatch, rejectWithValue, getState }) => {
    try {
      const workspace = await api.admin.workspaces.createWorkspace(name);
      // Get current workspaces from state
      const state = getState() as RootState;
      const currentWorkspaces = state.workspace.workspaces || [];

      if (workspace) {
        dispatch(
          workspaceActions.setWorkspaces([workspace, ...currentWorkspaces])
        );
        dispatch(workspaceActions.setCurrentWorkspace(workspace));
      }
      return workspace;
    } catch (e) {
      return handleError(e, rejectWithValue);
    }
  }
);

export const getWorkspacesThunk = createAsyncThunk<m.Workspace[]>(
  "workspace/list",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const workspaces = await api.admin.workspaces.getWorkspaces();
      dispatch(workspaceActions.setWorkspaces(workspaces));
      return workspaces;
    } catch (e) {
      return handleError(e, rejectWithValue);
    }
  }
);

export const updateWorkspaceThunk = createAsyncThunk<m.Workspace, m.Workspace>(
  "workspace/update",
  async (workspace, { dispatch, rejectWithValue }) => {
    try {
      const workspaces = await api.admin.workspaces.updateWorkspace(workspace);
      dispatch(workspaceActions.setWorkspaces(workspaces));
      return workspace;
    } catch (e) {
      return handleError(e, rejectWithValue);
    }
  }
);

export const deleteWorkspaceThunk = createAsyncThunk<m.Workspace, string>(
  "workspace/delete",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const workspaces = await api.admin.workspaces.deleteWorkspace(id);
      dispatch(workspaceActions.setWorkspaces(workspaces));
      return workspaces;
    } catch (e) {
      return handleError(e, rejectWithValue);
    }
  }
);
